export const ADD_FEATURE = 'inc/feature'
export const REMOVE_FEATURE = 'dec/feature'
export const CLEAR_FEATURE = 'clear/feature'